import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { LayoutCommonComponent } from "./core/layout/layout-common/layout-common.component";
import { LayoutMainComponent } from "./core/layout/layout-main/layout-main.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { HOM2400Component } from "./modules/main/home/hom2400/hom2400.component";

const routes: Routes = [
  {
    path: "",
    component: LayoutCommonComponent,
    children: [
      {
        path: "",
        loadChildren: () => import("src/app/modules/com/com.module").then((m) => m.ComModule),
      },
    ],
  },
  {
    path: "",
    component: LayoutMainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "main",
        loadChildren: () =>
          import("src/app/modules/main/main.module").then((m) => m.MainModule),
      },
    ],
  },
  { path: "**", component: HOM2400Component },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor() { }
}
